<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-col cols="12" class="mb-5">
      <PageTitle title="Criar notificação" />
    </b-col>
    <b-col cols="6" class="form-group">
      <label class="font-weight-bold">Título</label>
      <input
        type="text"
        class="form-control"
        v-model="fields.title"
        @input="requiredFields.title = ''"
        placeholder="Título da notificação"
      />
      <error-message :errorMessage="requiredFields.title" />
    </b-col>
    <b-col cols="6" class="form-group">
      <label class="font-weight-bold">Status</label>
      <SelectItems
        label="text"
        v-model="fields.status"
        :items="allNotificationStatus"
        @update:value="requiredFields.status = ''"
        :reduceFunction="(status) => status.id"
        placeholder="Selecione o status da notificação"
      />
      <error-message :errorMessage="requiredFields.status" />
    </b-col>
    <b-col cols="12" class="form-group">
      <label class="font-weight-bold">Texto</label>
      <ckeditor
        v-model="fields.text"
        :editor="editorSettings.type"
        :config="editorSettings.config"
        @input="requiredFields.text = ''"
      />
      <error-message :errorMessage="requiredFields.text" />
    </b-col>
    <b-col cols="12" class="mb-2">
      <b-button
        variant="danger"
        @click="
          $router.push({
            name: 'lojista-app-notificacoes'
          })
        "
      >
        <i class="fas fa-arrow-left mr-2"></i>
        Voltar
      </b-button>
      <b-button class="ml-3" variant="success" @click="save()">
        <i class="fas fa-save mr-2"></i>
        Salvar
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { mapActions, mapState } from 'vuex';
import PageTitle from 'Components/PageTitle.vue';

import makeToast from 'Mixins/makeToast';
import ErrorMessage from 'Components/ErrorMessage.vue';
import SelectItems from '../../../components/Inputs/SelectItems.vue';

import NOTIFICATION_STATUS from 'Enums/Notification/Status.js';
import UploadAdapter from '../../../utils/UploadAdapterAxios.js';
import UserTypes from '@/enums/UserTypes';

const UploadAdapterPlugin = (editor) => {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    const token = localStorage.getItem('token');
    return new UploadAdapter(loader, token);
  };
};

export default {
  name: 'SaveNotifications',
  mixins: [makeToast],
  components: { PageTitle, ErrorMessage, SelectItems },
  data() {
    return {
      NOTIFICATION_STATUS,
      fields: {
        id: '',
        status: NOTIFICATION_STATUS.ACTIVE,
        title: '',
        text: '',
      },
      requiredFields: {},
      editorSettings: {
        type: ClassicEditor,
        config: {
          extraPlugins: [UploadAdapterPlugin],
        },
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    allNotificationStatus() {
      const array = [];

      Object.keys(NOTIFICATION_STATUS).forEach((key) => {
        array.push({
          id: NOTIFICATION_STATUS[key],
          text: this.getNotificationStatusText(NOTIFICATION_STATUS[key]),
        });
      });

      return array;
    },
  },
  mounted() {
    const { id } = this.$route.params;
    this.fields.id = id || '';

    this.get();
  },
  methods: {
    ...mapActions('shopkeeper', ['saveNotification', 'getNotification']),
    get() {
      if (!this.fields.id) return;

      this.$store.dispatch('startLoader');

      this.getNotification({
        userId: this.userTypeId(),
        notificationId: this.fields.id,
      })
        .then((response) => {
          this.fields = response.data.data || {};
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer a notificação',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    save() {
      const request = {
        userId: this.userTypeId(),
        ...this.fields,
      };

      this.$store.dispatch('startLoader');

      this.saveNotification(request)
        .then((response) => {
          const { id } = response.data.data || {};
          this.fields.id = id;
          this.makeToast('Sucesso', 'Notificação salva com sucesso');

          this.$router.push({ name: 'lojista-app-notificacoes' });
        })
        .catch((error) => {
          this.handleErrorMessages(error.response.data.message);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    handleErrorMessages(errorMessages) {
      if (!errorMessages) return;

      Object.keys(errorMessages).forEach((key) => {
        this.$set(this.requiredFields, key, 'Campo obrigatório');
      });
    },
    getNotificationStatusText(status) {
      const texts = {
        [NOTIFICATION_STATUS.INACTIVE]: 'Inativo',
        [NOTIFICATION_STATUS.ACTIVE]: 'Ativo',
      };

      return texts[status] || NOTIFICATION_STATUS.INACTIVE;
    },
    userTypeId(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
    },
  },
};
</script>